// Competition V3 wiring. Stage sets these in apps/web/.env; production defaults keep V3 inert until release.
export const V3_API_URL = process.env.NEXT_PUBLIC_COMPETITION_V3_API_URL || 'https://api.cadinu.io/api/competitions/v3'
export const V3_ADDRESS = (process.env.NEXT_PUBLIC_COMPETITION_V3_ADDRESS || '') as `0x${string}` | ''
export const V3_CHAIN_ID = Number(process.env.NEXT_PUBLIC_COMPETITION_V3_CHAIN_ID || 56)
export const EXPLORER = 'https://bscscan.com'
// Quick picks only. Any ERC-20 may be the reward (2026-09-29 contract); symbol and decimals are always read on-chain.
// Default picks, in this order (2026-09-30): CADINU, CBON, USDT, USDC, WBNB. All five are listed on-chain (supportedRewardTokens).
export const V3_REWARD_TOKENS = (process.env.NEXT_PUBLIC_COMPETITION_V3_REWARD_TOKENS ||
  '0x76e112203eF59D445452ef7556386dD2DF3Ed914,0x6e64fCF15Be3eB71C3d42AcF44D85bB119b2D98b,0x55d398326f99059fF775485246999027B3197955,0x8AC76a51cc950d9822D68b83fE1Ad97B32Cd580d,0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c')
  .split(',')
  .map((a) => a.trim())
  .filter(Boolean) as `0x${string}`[]
/** The eight pool factories the contract accepts (verified on-chain 2026-09-30; the UI re-reads supportedFactories). */
export const DEXES = [
  { name: 'CADINUdex V3', kind: 'V3', factory: '0x2cb62aEBa8eB609020129983A5141DB883abca85' },
  { name: 'PancakeSwap V3', kind: 'V3', factory: '0x0BFbCF9fa4f9C56B0F40a671Ad40E0805A091865' },
  { name: 'Uniswap V3', kind: 'V3', factory: '0xdB1d10011AD0Ff90774D0C6Bb92e5C5c8b4461F7' },
  { name: 'CADINUdex V2', kind: 'V2', factory: '0x5DaF6fEd0E85218B275DB7D86001621043b561DA' },
  { name: 'PancakeSwap V2', kind: 'V2', factory: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73' },
  { name: 'Biswap', kind: 'V2', factory: '0x858E3312ed3A876947EA49d572A7C42DE08af7EE' },
  { name: 'BakerySwap', kind: 'V2', factory: '0x01bF7C66c6BD861915CdaaE475042d3c4BaE16A7' },
  { name: 'Uniswap V2', kind: 'V2', factory: '0x8909Dc15e40173Ff4699343b6eB8132c65e18eC6' },
] as const
export const dexByFactory = (f?: string) => DEXES.find((d) => d.factory.toLowerCase() === (f ?? '').toLowerCase())
export const TYPES = [
  { index: 0, key: 'VOLUME', label: 'Trading activity (volume)', short: 'Trade volume', help: 'Buys + sells of the project token. Repeated trading raises the score; this measures activity.' },
  { index: 1, key: 'PURCHASE_HOLD', label: 'Buy & hold', short: 'Buy & hold', help: 'Tokens bought during the competition × time held until the end. Selling or moving them out removes their score (oldest first).' },
]
/** release-web-20261009: the type lookup the home LivePanel imports. Follow-token web (0a670c2) defines it over TYPES + FOLLOW_TYPES;
 * this release carries no follow-token code, so it looks up the two live types only. */
export const typeOf = (key?: string) => TYPES.find((t) => t.key === key)
export const TIERS = [
  { range: '1–10', bps: 2000 },
  { range: '11–100', bps: 3000 },
  { range: '101–500', bps: 4500 },
  { range: '501+', bps: 6000 },
]
export const fetcher = (url: string) => fetch(url).then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
export const short = (a?: string) => (a ? `${a.slice(0, 6)}…${a.slice(-4)}` : '')
export function formatUnits18(v?: string | bigint, decimals = 18, digits = 4) {
  if (v === undefined || v === '') return '0'
  const n = BigInt(v)
  const base = 10n ** BigInt(decimals)
  const whole = n / base
  const frac = (n % base).toString().padStart(decimals, '0').slice(0, digits).replace(/0+$/, '')
  return frac ? `${whole.toLocaleString('en-US')}.${frac}` : whole.toLocaleString('en-US')
}
export const PHASE_LABEL: Record<string, string> = {
  upcoming: 'Upcoming',
  live: 'Live',
  awaiting_result: 'Awaiting result',
  refundable: 'Refund available',
  settled: 'Finished',
  refunded: 'Refunded',
}
